import { useRouter } from 'next/router';
import { useDispatch, useReduxState } from 'hooks';
import { SearchForm } from 'components/common';

interface Props {
  onSearchOrClear?: () => void;
  size?: 'header';
}

const UsersSearch = ({ onSearchOrClear, size }: Props) => {
  const { dispatch } = useDispatch();

  const { messages } = useReduxState();

  const router = useRouter();

  const handleClear = async () => {
    if (onSearchOrClear) onSearchOrClear();
    const queryParams = router.query || {};
    delete queryParams['search'];

    router.replace({ query: { ...queryParams, page: 1 } });
  };

  const handleError = async (err: Error) =>
    await dispatch.handleErrorDispatch(err);

  const handleSearch = async (value) => {
    if (onSearchOrClear) onSearchOrClear();
    router.replace({ query: { ...router.query, search: value, page: 1 } });
  };

  return (
    <SearchForm
      placeholderText={messages.usersSearchUsers}
      initialValue={router.query?.search || ''}
      onClear={handleClear}
      onError={handleError}
      onSearch={handleSearch}
      size={size}
    />
  );
};

export default UsersSearch;
